<script>
 import {game_3013} from "./game_3013";
 import DescribeLayout from "../common/describe_layout.vue";
export default {
  name: "Game3013",
  components: {DescribeLayout},
  props:{
    winValueTip:null,
    winValueTotal:null,
    isTotalWin:false,
    describe_title:null,
    describe_content:null,
    describe_message:null,
    winpos: [],
    lang: '',
    Phone:false,
  },
  data()
  {
    return {

    }
  },
  methods: {

    getColorCircleBg(pos)
    {
       return game_3013.getColorCircleBg(pos);
    },
    getMultiple(pos)
    {
      return game_3013.getMultiple(pos);
    },
    getAnimalIcon(pos)
    {
      return game_3013.getAnimalIcon(pos);
    },
    getFeature(type)
    {
      if(type === 2)
      {
        return `lang.str_three_yuan`;
      }
      else if(type === 1)
      {
        return `lang.str_luckiest_man`;
      }
      else if(type === 3)
      {
        return `lang.str_lightning_jet`;
      }
      return "lang.str_none"
    },
    getBetsList(betsInfo)
    {
       return game_3013.getBetsList(betsInfo);
    },
    getslideEndIndexFeatures(slideEndIndex)
    {
        let slideEndPos = [];
        //console.log(slideEndIndex);
        for (const [key, value] of Object.entries(slideEndIndex))
        {
          //console.log(value);
           let obj = new Object();
           obj.pos = value;
           obj.animal =  game_3013.getItemAnimalBg(value);
           obj.bgName = game_3013.getItemColorBg(value);
           slideEndPos.push(obj);
        }
       return slideEndPos;
    }
  },

}
</script>

<template>
  <div>
    <div style="display:flex;justify-content: space-between; text-align: left; padding:8px;">
      <div :style="{ 'width': Phone?`25%`:`10%`, 'vertical-align': 'center'}">
        {{ $t(`lang.str_hashbettype`) }}
      </div>
      <div :style="{ 'width': Phone?`75%`:`90%` }">
<!--      {{winpos}}-->
        <div style="display: flex; flex-direction: row; flex-wrap: wrap;">
          <div class="gameImgArea_5" :style="{ 'width': Phone?`78.5vw`:`500px` }">
            <div class="box box2" v-for="(item, index) in this.getBetsList(winpos.BetsInfo)" :key="index">
              <div>
                <div class="item_icon" :style="{'background': `url(${require('../../assets/luck_car/'+item.bgName+ '.png')})`, 'background-size': '100% 100%','opacity': item.betAmount>0?`1`:`0.2` }">
                  <img :src="require('../../assets/luck_car/' +  item.animal + '.png')" alt="" :class="{ deep: true }">
                </div>
                <div class="item_info" :style="{'opacity': item.betAmount>0?`1`:`0.4`}">
                  <p class="item_info_multiple">X{{ item.multiple}}</p>
                </div>
                <div class="item_betAmount">
                  <div  v-if="(item.betAmount > 0)">
                    <p>Bet:{{ (item.betAmount / 100).toFixed(2)}}</p>
                  </div>
                  <div v-else class="gray_color">
                    <p>Bet:0</p>
                  </div>
                </div>
                <div class="item_betAmount">
                  <div v-if="(item.winAmount >0)" class="yellow_color">
                    <p><span>Win:</span>{{ (item.winAmount / 100).toFixed(2)}}</p>
                  </div>
                  <div v-else class="gray_color">
                    <p>Win:-</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="gameImgArea_line">
      <div :style="{ 'width': Phone?`25%`:`10%`, 'vertical-align': 'center'}">
        {{ $t(`lang.str_hashresult`) }}
      </div>
      <div :style="{ 'width': Phone?`75%`:`90%` }">
        <div v-for="(item, index) in this.getslideEndIndexFeatures(winpos.slideEndIndexFeatures)" :key="index">
          <div class="item_icon" :style="{'background': `url(${require('../../assets/luck_car/'+item.bgName+ '.png')})`, 'background-size': '100% 100%' }">
            <img :src="require('../../assets/luck_car/' + item.animal + '.png')" alt="" :class="{ deep: true }">
          </div>
        </div>
      </div>
    </div>
    <div class="gameImgArea_line">
      <div :style="{ 'width': Phone?`25%`:`10%`, 'vertical-align': 'center'}">
        {{ $t(`lang.str_special_Games`) }}
      </div>
      <div :style="{ 'width': Phone?`75%`:`90%` }">
        {{  $t(getFeature(winpos.winFeature))}}
      </div>
    </div>
    <DescribeLayout
      :winValueTip="winValueTip"
      :winValueTotal="winValueTotal"
      :isTotalWin="isTotalWin"
      :describe_title = "describe_title"
      :describe_content = "describe_content"
      :describe_message="describe_message">
    </DescribeLayout>
  </div>
</template>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/esports/game_3013.vue